var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"widget-header"},[_c('span',{staticClass:"widget-header__title"},[_vm._v(_vm._s(_vm.$t('message.orderDetails.customerDetails')))])]),_c('div',{staticClass:"widget-details widget-info customer-details"},[(_vm.customer)?_c('CustomerDetails',{attrs:{"customer":_vm.customer}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }